import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult>({
    can_launch: boolean,
    errors: arrayOf(
      objectOf({
        title: string,
        copy: string,
        type: string,
        step_id: string,
      })
    ),
  });
